module.exports = __webpack_public_path__ + "static/media/logo8.ac57e9fb.png";